// client/src/utils/code.ts

/**
 * UI validation: 4–12 ASCII letters or digits (no spaces/symbols).
 * This matches the mock and is a subset of what the backend allows.
 */
export const CODE_RE = /^[A-Za-z0-9]{4,12}$/;

/**
 * Normalize to a backend-safe slug (lowercase, only [a-z0-9._-], max 64).
 * We keep this conservative so your links work across environments.
 */
export function toSlugForBackend(input: string): string {
  const s = (input || '').trim().toLowerCase().replace(/[^a-z0-9._-]+/g, '');
  return s.slice(0, 64);
}
